import { createSlice } from '@reduxjs/toolkit';

export const initialAtlasState = {
	requestGeneration: 0,
	urlLoadStatus: 'idle',
	statusLoadStatus: 'idle',
	referralUrl: null,
	mode: null,
	status: null,
	error: null
};

const atlasSlice = createSlice({
	name: 'atlas',
	initialState: initialAtlasState,
	reducers: {
		setUrlLoadStatus(state, action) {
			state.urlLoadStatus = action.payload || 'idle';
		},
		setReferralUrl(state, action) {
			const { referralUrl, mode } = action.payload || {};
			state.referralUrl = referralUrl || null;
			state.mode = mode || null;
		},
		setUrlLoadError(state, action) {
			const message = action.payload || null;
			state.error = message;
			if (message) {
				state.urlLoadStatus = 'error';
			}
		},
		setStatusLoadStatus(state, action) {
			state.statusLoadStatus = action.payload || 'idle';
		},
		setAtlasAliveStatus(state, action) {
			state.status = action.payload;
			state.statusLoadStatus = 'ready';
		},
		clearReferralUrlCache(state) {
			state.referralUrl = null;
			state.mode = null;
			state.urlLoadStatus = 'idle';
			state.error = null;
			state.status = null;
			state.statusLoadStatus = 'idle';
		},
		resetAtlasState(state) {
			return {
				...initialAtlasState,
				requestGeneration: state.requestGeneration + 1
			};
		}
	}
});

export const {
	setUrlLoadStatus,
	setReferralUrl,
	setUrlLoadError,
	setStatusLoadStatus,
	setAtlasAliveStatus,
	clearReferralUrlCache,
	resetAtlasState
} = atlasSlice.actions;

export const selectAtlasUrlLoadStatus = (state) => state.atlas.urlLoadStatus;
export const selectAtlasStatusLoadStatus = (state) => state.atlas.statusLoadStatus;
export const selectAtlasReferralUrl = (state) => state.atlas.referralUrl;
export const selectAtlasMode = (state) => state.atlas.mode;
export const selectAtlasStatus = (state) => state.atlas.status;
export const selectAtlasError = (state) => state.atlas.error;

export const selectAtlasIsLoading = (state) => {
	const { urlLoadStatus, statusLoadStatus } = state.atlas;
	return urlLoadStatus === 'loading' || statusLoadStatus === 'loading';
};

export default atlasSlice.reducer;
